import { CommonModule } from '@angular/common';
import { Injector, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AvanoToggleSwitchModule } from '../avano-toggle-switch/avano-toggle-switch.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BadgeModule } from 'primeng/badge';
import { AvanoAppHeaderModule } from '../avano-appheader/avano-appheader.module';
import { AvanoButtonModule } from '../avano-button/avano-button.module';
import { AvanoPopoverModule } from '../avano-popover/avano-popover.module';
import { NotificationsEffects } from './+state/notifications/notifications.effects';
import * as fromNotifications from './+state/notifications/notifications.reducer';
import { AvanoNotificationsItemComponent } from './components/avano-notification-item/avano-notifications-item.component';
import { AvanoNotificationsContainerComponent } from './components/avano-notifications-container/avano-notifications-container.component';
import { AvanoNotificationsHeaderComponent } from './components/avano-notifications-header/avano-notifications-header.component';
import { NotificationServiceBase } from './notification-service.base';
import { ROOT_SERVICE, _ROOT_SERVICE } from './tokens';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AvanoNotificationsContainerComponent, AvanoNotificationsItemComponent, AvanoNotificationsHeaderComponent],
  imports: [
    CommonModule,
    BadgeModule,
    AvanoPopoverModule,
    FormsModule,
    AvanoAppHeaderModule,
    AvanoButtonModule,
    AvanoToggleSwitchModule,
    StoreModule.forFeature(fromNotifications.NOTIFICATIONS_FEATURE_KEY, fromNotifications.reducer),
    EffectsModule.forFeature([NotificationsEffects]),
    TranslateModule.forChild({ extend: true })
  ],
  exports: [
    AvanoNotificationsContainerComponent
  ]
})
export class AvanoNotificationsModule {
static forRoot(rootService: Type<NotificationServiceBase>): ModuleWithProviders<AvanoNotificationsModule> {
  return {
    ngModule: AvanoNotificationsModule,
    providers: [
      {
        provide: _ROOT_SERVICE,
        useValue: rootService
      },
      {
        provide: ROOT_SERVICE,
        useFactory: createService,
        deps: [Injector, _ROOT_SERVICE]
      }
    ]
  }
}
}

export function createService(
  injector: Injector,
  service: Type<NotificationServiceBase>
): NotificationServiceBase {
  return injector.get(service);
}
